// Все "магические" значения расписания в одном месте
export const SCHEDULE_CONFIG = {
    POSITIV_ID: '82',
    INTERVAL: '30 minute',
    SLOT_MINUTES: 30,
    LOCALE: 'ru-KZ',

    // границы навигации
    DAYS_BACK: 2,            // сколько дней назад можно смотреть
    MAX_MONTHS_AHEAD: 9,     // на сколько месяцев вперёд

    // запрос одного дня: с 10:00 (как раньше) до конца суток
    DAY_START_HOUR: 10,
    // оставляем как в старом запросе (13) — безопасно для сервера, пока не выяснили его семантику
    REQUEST_LENGTH: 13,
};

export const WEEKDAYS = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];
export const WEEKDAYS_SHORT = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
